module.exports = __webpack_public_path__ + "static/media/sucursales_img.262a326b.svg";